<template>
  <div class="d-flex align-center align-self-stretch">
    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <div class="d-flex align-center mr-4" v-on="on">
          <v-icon :color="indicatorsColor" size="32px">
            mdi-account-multiple-outline
          </v-icon>
          <span :class="`${indicatorsColor}--text`">
            {{ totalSequencePeople || 0 }}
          </span>
        </div>
      </template>
      <span>{{ $t('general.peopleInTheSequence') }}</span>
    </v-tooltip>

    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <div class="d-flex align-center mr-4" v-on="on">
          <v-icon :color="indicatorsColor" size="32px">
            mdi-account-cancel-outline
          </v-icon>
          <span :class="`${indicatorsColor}--text`">
            {{ sequence.peopleThatLeftTheSequence || 0 }}
          </span>
        </div>
      </template>
      <span>{{ $t('general.peopleThatLeftTheSequence') }}</span>
    </v-tooltip>

    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <div class="d-flex align-center" v-on="on">
          <v-icon :color="indicatorsColor" size="32px">
            mdi-shoe-print
          </v-icon>
          <span :class="`${indicatorsColor}--text`">
            {{ sequenceTotalSteps }}
          </span>
        </div>
      </template>
      <span>{{ $t('general.sequenceSteps') }}</span>
    </v-tooltip>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState({
      sequenceTotalSteps: state => state.sequences.sequenceTotalSteps,
      totalSequencePeople: state => state.sequences.totalSequencePeople
    })
  },
  props: {
    indicatorsColor: {
      type: String,
      default: 'kbBlue'
    },
    sequence: {
      type: Object,
      default: () => {}
    }
  }
}
</script>
